<template>
    <div style="min-height: calc(100vh - 496px - 48px);">
        <DefaultSelfNonOpenForm v-model="playerList[0]" type="P"></DefaultSelfNonOpenForm>
    </div>
</template>
<script>
    import DefaultSelfNonOpenForm from "./DefaultSelfNonOpenForm";
    import participantMixin from "../../../mixins/participantMixin";

    export default {
        components: {DefaultSelfNonOpenForm},
        data() {
            return {

            }
        },
        mixins: [participantMixin],
        methods: {
        }
    }
</script>
